
export { default as prop } from "./prop.js"